import { useCallback } from "react";
import React, { createContext, useContext, useState } from "react";

const NavContext = createContext();

export const NavProvider = ({ children }) => {
  const [isNavDisabled, setIsNavDisabled] = useState(false);

  const enableNav = useCallback(() => setIsNavDisabled(false), []);
  const disableNav = useCallback(() => setIsNavDisabled(true), []);

  return (
    <NavContext.Provider value={{ isNavDisabled, enableNav, disableNav }}>
      {children}
    </NavContext.Provider>
  );
};

export const useNavContext = () => useContext(NavContext);
